import styled from 'styled-components';

export default styled.div`
    .mainApp__body {
        width: 100%;
        height: 100vh;
        display: flex;
    }
`;
